module.exports = __webpack_public_path__ + "img/checkbox.d713cf82.svg";